import { HStack } from "@chakra-ui/react";
import { Avatar, Link } from "@components/ui-kit";
import type { UserMonthlyReport } from "@src/__generated__/urql-graphql";
import { toApiDate } from "@src/utils/dates";
import { observer } from "mobx-react-lite";
import type { FunctionComponent } from "react";
import { useStore } from "../../../store";

interface UserNameProps {
  row: UserMonthlyReport;
}

export const UserName: FunctionComponent<UserNameProps> = observer(
  function UserName({ row: { id, user_image, user_full_name } }) {
    const store = useStore();

    const where = {
      AND: [
        {
          column: "TRACKED_FOR_DATE",
          value: [
            toApiDate(new Date(store.period.year, store.period.month, 1)),
            toApiDate(new Date(store.period.year, store.period.month + 1, 0)),
          ],
          operator: "BETWEEN",
        },
        { column: "USER_ID", value: [id], operator: "IN" },
        { AND: [{ OR: [] }] },
      ],
    };

    return (
      <HStack spacing={4}>
        <Avatar name={user_full_name} src={user_image} />
        <Link
          href={{
            pathname: "/reports/time-report",
            query: {
              page: "1",
              first: "10",
              where: JSON.stringify(where),
              search: "",
            },
          }}
        >
          {user_full_name}
        </Link>
      </HStack>
    );
  },
);
